export default "__VITE_ASSET__Dyrrgouu__"